module.exports = __webpack_public_path__ + "img/box_anim_bk21.33891449.png";